import PropTypes from 'prop-types';
import React from 'react';
import { connect as connectR } from 'react-redux';
import { Link } from 'react-router';
import { Button, Col, Row } from 'react-bootstrap';
import _ from 'lodash';
import LeftSide from '../main/left-side';
import translate from '../translate';
import OrderPostit from './forms/order-postit';
import LargeCard from '../main/large-card';
import VerticalNavigation from '../navigation/vertical-navigation';
import LinkButton from '../util/link-button';
import { LoadRouterSerialNumbers } from '../../store/serialNumbersSlice';
import {
    REQUEST_FAILURE,
    REQUEST_PENDING,
} from '../../store/network/managedRequest';
import {
    LoadLocation,
    LoadLocationsForMansionId,
    RequestConnectivityCheck,
    resetConnectivityCheckRequestState,
} from '../../store/locationsSlice';
import { LoadAppliancesByLocation } from '../../store/applianceSlice';
import { LoadMansions } from '../../store/mansionsSlice';
import RefreshButton from '../main/refresh-button';
import Postit from '../main/postit';
import {
    RequestPropertyLinkInfoForLocationId,
    RequestSendEmailForPropertyLink,
} from '../../store/propertyLinkSlice';
import OAuthPropertyLinkForm, {
    shouldRenderApaleoLinkForm,
} from './forms/property-link-form';
import { LoadPartners } from '../../store/partnerManagerSlice';
import {
    usingFeatureReadAccess,
    usingFeatureWriteAccess,
} from '../../util/usingFeatureAccess';
import { PbRequest } from '../../store/pbRequest';
import withParams from '../../nav/withParams';
import InstallationLinkCard from './installation-link-card';
import ValidatorFormGroup from '../main/validator-form-group';
import LocationPhoneUserCard from './forms/location-phone-user-card';

class LocationsDetails extends React.Component {
    static propTypes = {
        strings: PropTypes.object,
        params: PropTypes.shape({
            location_id: PropTypes.string,
            object_id: PropTypes.string,
        }).isRequired,
        LoadAppliancesByLocation: PropTypes.func.isRequired,
        LoadRouterSerialNumbers: PropTypes.func.isRequired,
        appliancesByLaundryRoom: PropTypes.shape({}).isRequired,
        selectedAccountingArea: PropTypes.shape({
            vip_costs_enabled: PropTypes.bool,
        }).isRequired,
        locationsByMansionsById: PropTypes.shape({}).isRequired,
        getLocationsByMansion: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        requestConnectivityCheckRequest: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        sendEmailForPropertyLinkRequest: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        sendEmailForPropertyLinkData: PropTypes.shape({}),
        RequestSendEmailForPropertyLink: PropTypes.func.isRequired,
        getPropertyLinkInfoRequest: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        getPropertyLinkInfoData: PropTypes.shape({}),
        RequestPropertyLinkInfoForLocationId: PropTypes.func.isRequired,
        RequestConnectivityCheck: PropTypes.func.isRequired,
        resetConnectivityCheckRequestState: PropTypes.func.isRequired,
        LoadLocation: PropTypes.func.isRequired,
        LoadLocationsForMansionId: PropTypes.func.isRequired,
        LoadMansions: PropTypes.func.isRequired,
        LoadPartners: PropTypes.func.isRequired,
        mansionsById: PropTypes.shape({}).isRequired,
    };

    componentDidMount() {
        this.props.LoadRouterSerialNumbers();
        this.props.LoadAppliancesByLocation(
            Number(this.props.params.location_id)
        );
        this.props.LoadLocation(Number(this.props.params.location_id));
        this.props.LoadLocationsForMansionId(
            Number(this.props.params.object_id)
        );
        this.props.LoadMansions();
        this.props.RequestPropertyLinkInfoForLocationId(
            this.props.params.location_id
        );
        this.props.LoadPartners();
    }

    reload = () => {
        const mansionId = Number(this.props.params.object_id);
        if (mansionId) {
            this.props.resetConnectivityCheckRequestState();
            this.props.LoadLocationsForMansionId(mansionId);
        }
    };

    requestConnectivityCheckAndReload = () => {
        const locationId = Number(this.props.params.location_id);
        if (locationId) {
            this.props.RequestConnectivityCheck(locationId, this.reload);
        }
    };

    renderConnectivityForm = (location) => {
        function formatTimestampOrElse(epochMillis, fallback) {
            return epochMillis
                ? new Date(epochMillis).toLocaleString('de-DE')
                : fallback;
        }

        function renderValue(value) {
            return (
                <div className="form-line">
                    <input
                        type="text"
                        className="form-control"
                        id=""
                        value={value}
                        disabled
                    />
                </div>
            );
        }

        const hasError =
            this.props.getLocationsByMansion.status === REQUEST_FAILURE ||
            this.props.requestConnectivityCheckRequest.status ===
                REQUEST_FAILURE;

        const reloadInProgress =
            this.props.getLocationsByMansion.status === REQUEST_PENDING;
        const anythingInProgress =
            reloadInProgress ||
            this.props.requestConnectivityCheckRequest.status ===
                REQUEST_PENDING;

        return (
            <div className="form-group">
                <label htmlFor="">
                    {this.props.strings.connectivityStateLabel}
                </label>
                {renderValue(
                    this.props.strings.connectivityState[
                        location.connectivity_state
                    ]
                )}

                <label htmlFor="">
                    {this.props.strings.connectivityCheckStateLabel}
                </label>
                {renderValue(
                    this.props.strings.connectivityCheckState[
                        location.connectivity_check_state
                    ] || '-'
                )}

                <label htmlFor="">
                    {this.props.strings.connectivityCheckUpdateTime}
                </label>
                {renderValue(
                    formatTimestampOrElse(
                        location.connectivity_check_update_time,
                        '-'
                    )
                )}

                {hasError && (
                    <div className="alert alert-danger">
                        {this.props.strings.generalError}
                    </div>
                )}
                <RefreshButton
                    loading={reloadInProgress}
                    onClick={this.reload}
                />
                <Button
                    onClick={this.requestConnectivityCheckAndReload}
                    disabled={anythingInProgress}
                    className="btn btn-primary pull-right mt-10"
                >
                    {anythingInProgress
                        ? '...'
                        : this.props.strings.requestConnectivityCheck}
                </Button>
            </div>
        );
    };

    renderApaleoLinkForm = (location) => {
        if (shouldRenderApaleoLinkForm(location)) {
            return (
                <Row>
                    <Col xs={8} sm={8} md={8} lg={8}>
                        <LargeCard
                            type="card-info"
                            title={[
                                location.name,
                                this.props.strings.propertyLink,
                            ]}
                        >
                            <OAuthPropertyLinkForm
                                location={location}
                                strings={this.props.strings}
                                requestApaleoLandingPageRequest={
                                    this.props.sendEmailForPropertyLinkRequest
                                }
                                requestApaleoLandingPageData={
                                    this.props.sendEmailForPropertyLinkData
                                }
                                getPropertyLinkInfoRequest={
                                    this.props.getPropertyLinkInfoRequest
                                }
                                getPropertyLinkInfoData={
                                    this.props.getPropertyLinkInfoData
                                }
                                onLandingPageEmailButtonClicked={(
                                    requestPayload
                                ) =>
                                    this.props.RequestSendEmailForPropertyLink(
                                        requestPayload
                                    )
                                }
                            />
                        </LargeCard>
                    </Col>
                </Row>
            );
        } else {
            return null;
        }
    };

    renderPhoneUserCardAndPostIt(location) {
        const dialNumber = location?.phone_user_dial_number;
        return (
            <Row>
                <Col xs={8} sm={8} md={8} lg={8}>
                    <LocationPhoneUserCard location={location} />
                </Col>
                <Col xs={4} sm={4} md={4} lg={4}>
                    <Postit title={this.props.strings.phoneUserPostit.title}>
                        <div>
                            <div className={'mb-2'}>
                                {dialNumber ||
                                    this.props.strings.phoneUserPostit
                                        .unknownPhoneNumber}
                            </div>
                            <p className={'mb-2'}>
                                {this.props.strings.phoneUserPostit.usageNote}
                            </p>
                            <p style={{ opacity: 0.8 }}>
                                {this.props.strings.phoneUserPostit.ratesNote}
                            </p>
                        </div>
                    </Postit>
                </Col>
            </Row>
        );
    }

    render() {
        const mansionId = Number(this.props.params.object_id);
        const locationId = Number(this.props.params.location_id);
        const locationsByMansions =
            this.props.locationsByMansionsById[mansionId] || {};
        const object = this.props.mansionsById[mansionId];
        const location = locationsByMansions[locationId];

        const hasWriteLocation = usingFeatureWriteAccess(
            this.props.selectedAccountingArea,
            'RESIDENTIAL_LOCATION'
        );
        const hasWriteAppliances = usingFeatureWriteAccess(
            this.props.selectedAccountingArea,
            'RESIDENTIAL_APPLIANCE'
        );
        const hasReadAppliances = usingFeatureReadAccess(
            this.props.selectedAccountingArea,
            'RESIDENTIAL_APPLIANCE'
        );
        const hasRolesAccess = usingFeatureWriteAccess(
            this.props.selectedAccountingArea,
            'GENERAL_ACCESS_MANAGEMENT'
        );

        if (!object || !location || !this.props.selectedAccountingArea) {
            return <div> Loading </div>;
        }

        const appliancesForDisplay =
            this.props.appliancesByLaundryRoom[locationId] || {};

        return (
            <Row>
                <LeftSide addClass="">
                    <VerticalNavigation
                        selected="objects"
                        selectedObject={object.id}
                        objects={this.props.mansionsById}
                        selectedLocation={location.id}
                        locations={this.props.locationsByMansionsById}
                        appliances={appliancesForDisplay}
                    />
                    {hasWriteLocation && <OrderPostit />}
                </LeftSide>

                <Col xs={9} sm={9} md={9} lg={9} className="col-middle">
                    <Row>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <LargeCard
                                title={[location.name]}
                                testId="location-name"
                            >
                                <div style={{ display: 'flex' }}>
                                    <ValidatorFormGroup
                                        label={this.props.strings.washing}
                                    >
                                        <input
                                            className="form-control"
                                            disabled
                                            data-testid="washing-cost"
                                            value={this.props.strings._utils.formatPrice(
                                                {
                                                    amount: location.washer_cost,
                                                    currency:
                                                        location.currency_type ||
                                                        'EUR',
                                                }
                                            )}
                                        />
                                    </ValidatorFormGroup>
                                    <ValidatorFormGroup
                                        label={this.props.strings.drying}
                                    >
                                        <input
                                            className="form-control"
                                            disabled
                                            data-testid="drying-cost"
                                            value={this.props.strings._utils.formatPrice(
                                                {
                                                    amount: location.dryer_cost,
                                                    currency:
                                                        location.currency_type ||
                                                        'EUR',
                                                }
                                            )}
                                        />
                                    </ValidatorFormGroup>
                                </div>

                                <Row>
                                    <LinkButton
                                        text={this.props.strings.edit}
                                        to={`/objects/${object.id}/${location.id}/overview`}
                                        pullRight
                                        marginTop="0em"
                                        data-testid="edit-location-button"
                                    />
                                    {hasWriteLocation &&
                                        this.props.selectedAccountingArea
                                            .vip_costs_enabled && (
                                            <LinkButton
                                                text={
                                                    this.props.strings
                                                        .vipUserPricingButton
                                                }
                                                to={`/objects/${this.props.params.object_id}/${this.props.params.location_id}/vip-user-pricing`}
                                                marginTop="0em"
                                                pullRight
                                                className="mr-10"
                                            />
                                        )}
                                </Row>
                            </LargeCard>
                        </Col>
                    </Row>
                    {hasRolesAccess && (
                        <Row>
                            <Col xs={8} sm={8} md={8} lg={8}>
                                <InstallationLinkCard location={location} />
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <LargeCard
                                type="card-edit"
                                title={this.props.strings.appliances}
                            >
                                <table
                                    className="data-table"
                                    style={{ width: '100%' }}
                                >
                                    <thead>
                                        <tr>
                                            <th>
                                                {this.props.strings.description}
                                            </th>
                                            <th>
                                                {this.props.strings.shortText}
                                            </th>
                                            <th>
                                                {
                                                    this.props.strings
                                                        .serialNumber
                                                }
                                            </th>
                                            <th>{this.props.strings.note}</th>
                                            <th />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_.map(
                                            appliancesForDisplay,
                                            (appliance) => (
                                                <tr key={appliance.id}>
                                                    <td>
                                                        {appliance.local_name}
                                                    </td>
                                                    <td>
                                                        {appliance.short_name}
                                                    </td>
                                                    <td>
                                                        {
                                                            appliance.serial_number
                                                        }
                                                    </td>
                                                    <td>
                                                        {!appliance.enabled &&
                                                            this.props.strings
                                                                .disabled}
                                                    </td>
                                                    <td>
                                                        {hasReadAppliances && (
                                                            <Link
                                                                to={`/objects/${object.id}/${location.id}/${appliance.id}`}
                                                                className="icon icon-wew-button-enter icon-sm"
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                                <div className={'mt-2'}>
                                    {hasWriteAppliances && (
                                        <Link
                                            className="icon icon-wew-setting icon-sm"
                                            to={`/objects/${this.props.params.object_id}/${this.props.params.location_id}/create-appliance`}
                                        >
                                            {' '}
                                            {this.props.strings.add1}{' '}
                                            {this.props.strings.add2}
                                        </Link>
                                    )}
                                </div>
                            </LargeCard>
                        </Col>
                    </Row>
                    {hasWriteLocation && (
                        <Row>
                            <Col xs={8} sm={8} md={8} lg={8}>
                                <LargeCard
                                    type="card-info"
                                    title={[this.props.strings.connectivity]}
                                >
                                    {this.renderConnectivityForm(location)}
                                </LargeCard>
                            </Col>
                            <Col xs={4} sm={4} md={4} lg={4}>
                                <Postit
                                    title={
                                        this.props.strings.connectivityPostit
                                            .title
                                    }
                                >
                                    <p>
                                        {
                                            this.props.strings
                                                .connectivityPostit.text
                                        }
                                    </p>
                                </Postit>
                            </Col>
                        </Row>
                    )}
                    {hasWriteLocation && this.renderApaleoLinkForm(location)}
                    {location.partner_manages_phone_users &&
                        this.renderPhoneUserCardAndPostIt(location)}
                </Col>
            </Row>
        );
    }
}

export default connectR(
    (store) => ({
        appliancesByLaundryRoom: store.appliance.appliancesByLaundryRoom,
        requestConnectivityCheckRequest:
            store.pbRequest[PbRequest.REQUEST_CONNECTIVITY_CHECK],
        getLocationsByMansion:
            store.pbRequest[PbRequest.GET_LOCATIONS_BY_MANSION],
        locationsByMansionsById: store.locations.locationsByMansionsById,
        selectedAccountingArea: store.partnerManager.selectedPartner,
        mansionsById: store.mansions.mansionsById,
        sendEmailForPropertyLinkRequest:
            store.pbRequest[PbRequest.SEND_EMAIL_FOR_PROPERTY_LINK_REQUEST],
        getPropertyLinkInfoRequest:
            store.pbRequest[PbRequest.GET_PROPERY_LINK_INFO_REQUEST],
        sendEmailForPropertyLinkData:
            store.propertyOAuthLink.sendEmailForPropertyLinkData,
        getPropertyLinkInfoData: store.propertyOAuthLink.propertyLinkInfoData,
    }),
    {
        LoadRouterSerialNumbers,
        LoadAppliancesByLocation,
        LoadLocation,
        LoadLocationsForMansionId,
        LoadMansions,
        RequestConnectivityCheck,
        resetConnectivityCheckRequestState,
        RequestSendEmailForPropertyLink,
        RequestPropertyLinkInfoForLocationId,
        LoadPartners,
    }
)(translate('LocationsDetails')(withParams(LocationsDetails)));
